import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { EquipmentStatusDocument, equipmentStatusPullQueryBuilder } from './queryBuilder';

export function equipmentStatusFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<EquipmentStatusDocument> {
  const syncConfig = configBuilder<EquipmentStatusDocument>(RxdbCollectionNameV2.EQUIPMENT_STATUS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, equipmentStatusPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy has syncInterval at LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.EQUIPMENT_STATUS, replicationState, [sites]);
}
